import React from "react";
import ATargetList from "../../../../form/operationlist/TargetList";

export default class TargetList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const propsTop = this.props;
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        return props.values[props.componentConfig.idfield] && <ATargetList
            ref={(list) => {
                this.list = list;
                parent.picklist = list;
            }}
            loading={props.isLoading}
            className={"p-small-table"}
            data={props.values}
            saveChanges={props.setFieldValue}
            source={{
                ...pool
            }}
            onSourceItemUpdate={propsTop.onSourceItemUpdate || parent.onSourceItemUpdate}
            onTransferItems={parent.onTransferItems}
            onTargetItemUpdate={parent.onTargetItemUpdate}
            control={propsTop.control}
            target={{
                pageSize: 0,
                actions: false,
                ...operationitems,
                ...(!!props.actions ? {selection: {}} : {}),
                exports: []
            }}
            {...props.getProps("items")}
        />
    }
}